
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { WPXFormValue } from '@/components/templates/WPXForm';
import CreateScoreTypeForm from '@/services/QA/scoreType/forms/CreateScoreTypeForm';
import { ScoreTypeRepositoryInterface } from '@/services/QC-V2/score-type/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'scoreTypeRepositoryV2',
  ],
})
export default class CreateScoreType extends Vue {
  private readonly scoreTypeRepositoryV2!: ScoreTypeRepositoryInterface;
  private loading: boolean = true;
  private form: WPXFormValue<CreateScoreTypeForm> = new WPXFormValue(CreateScoreTypeForm);

  public created(): void {
    this.loading = false;
  }

  private async createScoreType(): Promise<void> {
    try {
      await this.scoreTypeRepositoryV2.createScoreType({
        label: this.form.data.label,
      });

      this.$successDialog.show(`Score Type '${this.form.data.label}' has been created`);
      await this.$router.push({ name: 'scores' });
    } catch (err) {
      this.$errorDialog.show(err.response.data.message);
    }
  }
}
